import { render } from "./dx-shukkinbo-input.vue?vue&type=template&id=06070c36"
import script from "./dx-shukkinbo-input.vue?vue&type=script&lang=js"
export * from "./dx-shukkinbo-input.vue?vue&type=script&lang=js"

import "./dx-shukkinbo-input.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__